import { render, staticRenderFns } from "./ViewEdit.vue?vue&type=template&id=330934b9"
import script from "./ViewEdit.vue?vue&type=script&lang=ts"
export * from "./ViewEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports